import { render, staticRenderFns } from "./ulkeaktar.vue?vue&type=template&id=66d0bca0&scoped=true"
import script from "./ulkeaktar.vue?vue&type=script&lang=js"
export * from "./ulkeaktar.vue?vue&type=script&lang=js"
import style0 from "./ulkeaktar.vue?vue&type=style&index=0&id=66d0bca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0bca0",
  null
  
)

export default component.exports